<template>
  <div class="project-list">
    <slot name="inner" />
    <Emtry v-if="!list.length" />
  </div>
</template>

<script>
import { TradeMode } from '@/enums'
import { MySocket } from '@/utils/webSocket'
import Emtry from '@/components/base/Emtry.vue'
export default {
  components: {
    Emtry
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    connectSocket: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      websocket: null
    }
  },
  computed: {
    // 项目是否已结束
    isProjectEnd() {
      return function(project) {
        switch (project.tradeMode) {
          case TradeMode.AUCTION:this.isAuctionPorjectEnd(project.state); break
        }
      }
    },
    // 竞拍项目是否已结束
    isAuctionPorjectEnd() {
      return function(state) {
        return [7, 8, 9, 10].includes(state)
      }
    },
    // socket订阅地址
    subscribeUrl() {
      return function(project) {
        switch (project.tradeMode) {
          case TradeMode.AUCTION:return '/topic/auction/' + project.projectNo
        }
      }
    }
  },
  watch: {
    // list: {
    //   handler(newVal, oldVal) {
    //     if (this.connectSocket) {
    //       this.initSocket()
    //     }
    //   },
    //   immediate: true,
    //   deep: true
    // }
  },
  created() {
    // if (this.connectSocket) {
    //   this.initSocket()
    // }
  },
  destroyed() {
    // this.websocket?.stompClient?.disconnect() // 关闭socket连接
    // window.removeEventListener('online', this.handleWsOnline)
    // window.removeEventListener('offline', this.handleWsOffline)
  },
  methods: {
    // 初始化 socket连接
    initSocket() {
      if (this.websocket) {
        this.websocket.doUnSubscribes()
      }
      this.websocket = new MySocket({
        url: process.env.VUE_APP_WS_API
      })
      this.websocket.doConnect().then(() => {
        this.list.forEach((item, index) => {
          if (!this.isProjectEnd(item)) {
            this.websocket.doSubscribe(
              this.subscribeUrl(item),
              (msg) => {
                console.log('82', JSON.parse(msg.body))
                // 订阅列表的每条消息
                this.onHandleSocketResEvent(index, JSON.parse(msg.body))
              }
            )
          }
        })
      })
      window.addEventListener('online', this.handleWsOnline)
      window.addEventListener('offline', this.handleWsOffline)
    },
    // 处理网络在线
    handleWsOnline() {
      console.log('handleWsOnline')
      this.websocket = new MySocket({
        url: process.env.VUE_APP_WS_API
      })
      this.websocket.doConnect().then(() => {
        this.list.forEach((item, index) => {
          this.websocket.doSubscribe(
            this.subscribeUrl(item),
            (msg) => {
              // 订阅列表的每条消息
              this.onHandleSocketResEvent(index, JSON.parse(msg.body))
            }
          )
        })
        this.$notify({
          type: 'success',
          title: '提示',
          message: '连接成功。',
          duration: 5000
        })
      })
    },
    // 处理网络离线
    handleWsOffline() {
      this.websocket?.stompClient?.disconnect()
      this.$notify({
        type: 'warning',
        title: '提示',
        message: '网络异常，正在尝试重新连接...',
        duration: 5000
      })
    },
    // 处理socket响应的事件
    onHandleSocketResEvent(index, resBody) {
      switch (resBody.event) {
        case 'stateChange':
          this.handleStateChange(index, resBody)
          break
        case 'delayed':
          this.handleDelayed(index, resBody)
          break
        case 'bid':
          this.handleBid(index, resBody)
          break
        case 'end':
          this.handleEnd(index, resBody)
          break
      }
    },
    // 处理-项目状态
    handleStateChange(index, resBody) {
      this.$set(
        this.list[index],
        'state',
        resBody.state - 0
      )
      this.$set(
        this.list[index],
        'stateDesc',
        resBody.stateDesc
      )
      this.$set(this.list[index], 'sysDate', resBody.sysDate)
    },
    // 处理-项目延时
    handleDelayed(index, resBody) {
      this.$set(this.list[index], 'sysDate', resBody.sysDate)
      this.$set(
        this.list[index],
        'stateEndTime',
        resBody.endTime
      )
    },
    // 处理-出价
    handleBid(index, resBody) {
      this.$set(
        this.list[index],
        'currentPrice',
        resBody.currentPrice
      )
    },
    // 处理-项目结束
    handleEnd(index, resBody) {
      this.$set(this.list[index], 'state', resBody.state - 0)
      this.$set(
        this.list[index],
        'stateDesc',
        resBody.stateDesc
      )
      this.$set(this.list[index], 'stateEndTime', resBody.endTime)
      this.$set(this.list[index], 'remark', resBody.remark)
    }
  }

}
</script>

<style lang="scss" scoped>
.project-list{
  display: flex;
  flex-wrap: wrap;
}
</style>
